import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { changeLocale, IntlContextConsumer } from "gatsby-plugin-intl";

import { GlobalDispatchContext, GlobalStateContext } from "Components/context";

const SelectionWrapper = styled.div`
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-left: 1px solid ${(props) => props.theme.color.grey};
`;

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${(props) => props.theme.font.sans};
  font-size: 0.6rem;
  height: 100%;
  padding: 0 0.8rem;
  opacity: 0.95;
  background-color: ${(props) => props.theme.color.cream};
  border-radius: 2px;
  font-weight: bold;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const StyledLanguage = styled.div`
  margin-left: 4px;
`;

const MenuWrapper = styled.div`
  top: calc(100% + 0.4rem);
  right: 0.1rem;
  min-width: calc(100% + 2rem);
  border-radius: 2px;
  position: absolute;
  background-color: white;
  z-index: 999;
  display: ${(props) => (props.isShown ? "block" : "none")};
  border: 1px solid ${(props) => props.theme.color.smoke};
  border-radius: 0px 0px 2px 2px;
`;

const OptionWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${(props) => props.theme.color.smoke};
  font-family: ${(props) => props.theme.font.sans};
  font-size: 0.9rem;
  font-weight: normal;
  padding: 0.8rem 0.4rem;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.color.smoke};
  }
  ${(props) => props.theme.responsive.desktop} {
    font-size: 0.7rem;
  }
`;

const getLangName = (lang) => {
  switch (lang) {
    case "en":
      return "English";
    case "it":
      return "Italiano";
    case "es":
      return "Español";
    default:
      return "Eng";
  }
};

const LanguageMenu = ({ color, ...props }) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const { currencyCountry } = state;

  const handleLanguageChange = (language) => {
    changeLocale(language);
    setShowLanguageMenu(false);
  };

  return (
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) => (
        <SelectionWrapper>
          <StyledButton
            onClick={() =>
              dispatch({
                type: "SET_IS_INTL_POPUP_SHOWN",
                isShown: !state.isIntlPopupShown,
              })
            }
          >
            <StyledLanguage>{getLangName(currentLocale)}</StyledLanguage>
          </StyledButton>
        </SelectionWrapper>
      )}
    </IntlContextConsumer>
  );
};

export default LanguageMenu;
